let language = {
    QP_LAZY_IMAGE_ERROR_TITLE: "click to reload the image again.",
};

export { language }